var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitAppV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "23px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0  L 184.65 0  L 184.65 188.76  L 0 188.76  Z ",
    fillRule: "evenodd",
    fill: "black",
    id: "path22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path22"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.5,16.13h-51.49c-.32,0-.64.03-.95.06-.31-.04-.63-.06-.95-.06-4.28,0-7.75,3.47-7.75,7.75v47.74c0,4.28,3.47,7.75,7.75,7.75s7.75-3.47,7.75-7.75V31.62h45.64c4.28,0,7.75-3.47,7.75-7.75s-3.47-7.75-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.5,156.83h-45.64v-44.27h13.6v19.92l30.51-30.51-30.51-31.46v18.65H11.7c-6.46,0-11.7,5.24-11.7,11.7h0c0,6.46,5.24,11.7,11.7,11.7h30.67v52.01c0,4.28,3.47,7.75,7.75,7.75.32,0,.64-.03.95-.06.31.04.63.06.95.06h51.49c4.28,0,7.75-3.47,7.75-7.75s-3.47-7.75-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "118.57 0 118.57 188.76 184.65 169.16 184.65 21.18 118.57 0"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50.00%",
    y: "-50.00%",
    width: "200.00%",
    height: "200.00%",
    filterUnits: "objectBoundingBox",
    id: "filter24"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 1  0 1 0 0 1  0 0 1 0 1  0 0 0 1 0  ",
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -344 -25 )"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.11914432710533442 0 0 0.11914432710533442 344 25.25515840779854 )",
    clipPath: "url(#clip23)",
    filter: "url(#filter24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.5,16.13h-51.49c-.32,0-.64.03-.95.06-.31-.04-.63-.06-.95-.06-4.28,0-7.75,3.47-7.75,7.75v47.74c0,4.28,3.47,7.75,7.75,7.75s7.75-3.47,7.75-7.75V31.62h45.64c4.28,0,7.75-3.47,7.75-7.75s-3.47-7.75-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.5,156.83h-45.64v-44.27h13.6v19.92l30.51-30.51-30.51-31.46v18.65H11.7c-6.46,0-11.7,5.24-11.7,11.7h0c0,6.46,5.24,11.7,11.7,11.7h30.67v52.01c0,4.28,3.47,7.75,7.75,7.75.32,0,.64-.03.95-.06.31.04.63.06.95.06h51.49c4.28,0,7.75-3.47,7.75-7.75s-3.47-7.75-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "118.57 0 118.57 188.76 184.65 169.16 184.65 21.18 118.57 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitAppV2);
export default __webpack_public_path__ + "static/media/exit-app-v2.bd41d77361f37b77c9dd124b9e6babef.svg";
export { ForwardRef as ReactComponent };